import angular from 'angular';
import crmCalendar from './crmCalendar';
import './style.scss';

export default angular
  .module('components.crmCalendar', [])
  .component('crmCalendar', crmCalendar).name;
